module.exports = __webpack_public_path__ + "static/media/image1_thumb.8af2ebcc.jpeg";